import { gql } from '@apollo/client';

export default gql`
  query refundMethods($bookingReference: String!) {
    refundMethods(bookingReference: $bookingReference) {
      code
    }
  }
`;
